import { Alert, Typography } from '@mui/material'
import React from 'react'
import * as Texts from '../../../../../intl'
import { SimulationDatesPicker } from '../primitives/SimulationDatesPicker'
import type { SimulationDate } from '../primitives/SimulationDatesPicker/typings'
import { PublicProps } from './typings'
import { useSimulationDatesPickerField } from './useSimulationDatesPickerField'

const RECURRENT_ORDER_ALERT_DISPLAY_TYPES = ['fromArchived', 'fromOperations']

const SimulationDatesPickerField: React.FC<PublicProps> = props => {
  const { wrappedInputProps } = props

  const { field, simulationDateError, handleOnChange, handleOnChangeType } =
    useSimulationDatesPickerField({
      today: wrappedInputProps.today,
      firstDayNotArchived: wrappedInputProps.firstDayNotArchived,
    })

  const isDisplayRecurrentOrdersAlert = RECURRENT_ORDER_ALERT_DISPLAY_TYPES.includes(
    field.value.type,
  )

  return (
    <>
      <SimulationDatesPicker
        {...wrappedInputProps}
        onChangeType={handleOnChangeType}
        onChange={handleOnChange}
        value={field.value as SimulationDate}
        hasError={!!simulationDateError}
      />

      {simulationDateError && (
        <Alert severity="error" sx={{ border: 'none', backgroundColor: 'transparent' }}>
          <Typography
            variant="caption"
            color="error"
            display="block"
            sx={{ whiteSpace: 'pre-line' }}
          >
            {simulationDateError.message}
          </Typography>
        </Alert>
      )}

      {isDisplayRecurrentOrdersAlert && (
        <Alert severity="info">{Texts.getRecurrentOrdersBannerText()}</Alert>
      )}
    </>
  )
}

export default SimulationDatesPickerField
